import { useEffect, useState } from "react";
import { navLinks, siteName } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkColor = scrolled
    ? "text-foreground-700 hover:text-primary-600"
    : "text-background-50/90 hover:text-background-50";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-10 flex items-center justify-between h-16">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 text-lg">
            <i className="ri-book-2-fill" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-2xl leading-none tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            {siteName}
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm whitespace-nowrap transition-colors ${linkColor}`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#library"
          className="hidden lg:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-background-50 text-sm px-5 h-10 hover:bg-primary-600 transition-colors"
        >
          <i className="ri-search-eye-line" aria-hidden="true"></i>
          开始找漫画
        </a>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-2xl ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <ul className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#library"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm py-2.5"
          >
            <i className="ri-search-eye-line" aria-hidden="true"></i>
            开始找漫画
          </a>
        </div>
      )}
    </header>
  );
}